import { Report } from '@/type';
import { ReportGenerated } from '@/messaging/events';
import eventBus from '@/messaging/event-bus';
import api from '../../../API';

export function exportToReport(postSearchId: number, reportName: string): Promise<Report> {
  return api
    .post(`post-searches/${postSearchId}/reports`, { reportName })
    .then((response) => {
      const report = (response.data as Report);
      const event = new ReportGenerated(report.id);
      eventBus.$emit(ReportGenerated.eventName, event);
      return report;
    });
}
